import React from 'react';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { FacebookIcon, TwitterIcon } from 'react-share';
import Modal from '../baseModal';

const Share = ({ url, onClose, title: quoteTitle }) => {
  const title = {
    id: 'modal.share',
    defaultMessage: 'Share',
  };

  return (
    <Modal onClose={onClose} title={title} modalType="share">
      <div className="nmodal nmodal-share">
        <div className="nmodal-dialog sm-nmodal-dialog-centered sm-nmodal-share-content">
          <div className="nmodal-content share-content">
            <div className="nmodal-body modal-body-no-padding">
              <div className="share-img"></div>
              <div className="share-links">
                <FacebookShareButton url={url} quote={quoteTitle}>
                  <FacebookIcon size={50} round />
                </FacebookShareButton>
                <TwitterShareButton url={url} title={quoteTitle}>
                  <TwitterIcon size={50} round />
                </TwitterShareButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Share;
